import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, Input, SimpleChanges} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ScannerApiService } from '../../services/scanner/scanner-api.service';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { ActionSheetController, AlertController, ModalController, Platform, PopoverController, ToastController } from '@ionic/angular';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { NetworkService } from '../../services/network.service';
import { AoxMeasurementResult } from '../../interfaces/biozoom-api/aox-measurement-result';
import { ApiBasicService } from '../../services/api/api-basic.service';
import { PipelineStageConfig, ResultType, StatusObject } from 'src/app/interfaces/biozoom-api/pipeline';
import { GenConfigService } from '../../services/gen-config.service';
import { genElements } from '../../methods/gen-html';
import { WindowObservablesService } from '../../services/window-observable';
import { ElementDesign, GeneralState, State } from '../../interfaces/biozoom-api/app-configuration';
import { Scanner } from '../../interfaces/scanner-api/scanner';
import { UsbApiService } from '../../services/scanner/usb-api.service';
import { ScannerStatus } from '../../interfaces/scanner-api/scanner-status';
import { Network } from '@ionic-native/network/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { NavigationBar } from '@ionic-native/navigation-bar/ngx';
import { AndroidFullScreen } from '@awesome-cordova-plugins/android-full-screen/ngx';
import { getKeyVal } from '../../methods/helpers';
import { HrvMeasurementData } from '../../interfaces/biozoom-api/hrv-measurement-data';
import { UsbApiService2 } from '../../services/scanner/usb-api2.service';
import { FileManagerService } from '../../services/fileManager/file-manager.service';
import { HomePageHelpers } from './home.helpers';
import { KeyValue } from '@angular/common';
import { environment } from '../../../environments/environment';
import { CheckerDataService } from '../../config-checker/services/checker-data.service';
import { Subscription } from 'rxjs';
import { AppConfigService } from '../../services/app-config.service';
import { VirtualKeyboardService } from '../../shared/virtual-keyboard/virtual-keyboard.service';


@Component({
  selector: 'app-precision',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit, OnDestroy, AfterViewChecked {

  // variables used for the html part
  lastPage = '';
  heading: string;
  text: string;
  progress: number[] = [];
  barIsMeasured: boolean[] = [];
  instructionLink: string;
  step: string;
  @Input() elementConfig = {};
  @Input() pageConfig: Record<string, any> = {};
  confirmed = true;
  @Input() state: GeneralState = { persistentValues: {} };
  windowDim: { w: number, h: number } = { w: 0, h: 0 };
  @Input() languageStore: Record<string, string> = {};
  media: Record<string, string> = {};
  hrvProgress: number;
  hrvBarIsMeasured: boolean;
  blockScreen: boolean;
  videoFinished = true;
  isElectron: any;
  configCheckerEnabled = false;
  private _kioskMode = false;

  private lastTS: number = Date.now();

  // internal variables
  private serial: string;
  private measurements: any[];
  private numMeasurements: number;
  private idx: number;
  private timeout: number;
  private aoxData: AoxMeasurementResult[] = [];
  // input object for each pipeline stage
  private stateObj: StatusObject = {};
  private result: ResultType = undefined;
  private STORAGE_ID = 'STATE';
  private scanner: Scanner;
  private lastTimeBackPress = 0;
  private timePeriodToExit = 2000;
  private networkType: string;
  private orientationLock = true;
  private orientationValue: string;
  private hrvMeasurement: any;
  private lastEnter = 0;
  private stageHistory: string[] = [];
  private lastRenderedPage: string = undefined;
  private didPostIframe = true;
  private submittedPostIframeKey = '';

  private lock = false;
  private lastCheck = 0;
  private lastBackChecked = 0;
  private usbCheckUp = false;
  private windowSizeSubscription?: Subscription;
  private trustedIframeUrls = new Map<string, SafeResourceUrl>();
  protected readonly getKeyVal = getKeyVal;

  helperFunctions: {
    setAlive: ((state: boolean) => void);
    getKeyValParser: ((m: ElementDesign) => string),
    getKeyValWrapper: ((m: ElementDesign) => string),
    checkBarcode: (() => void),
    registerBackButtonEvent: (() => void),
    stageValidator: (() => Promise<{status: boolean, message: string, nextStage: string}>),
    shrinkText: (() => void),
    calcElements: ((step: string) => Promise<void>),
    setBlockScreen: ((block: boolean) => void),
    initPage: (() => Promise<void>),
    resetPage: ((skipTo: string) => void),
    getSendState: (() => string),
    getState: ((key: State) => any),
    getNetworkType: (() => string),
    pushToLog: ((msg: any, group?: string) => void),
    setStateObj: ((key: string, val: any) => void),
    setStep: ((config: {
      step?: string,
      instructionLink?: string,
      progress?: number,
      measurement?: any,
      idx?: number,
      aoxData?: AoxMeasurementResult[],
      delete?: boolean
      hrvMeasurement?: any,
      hrvProgress?: number,
      hrvDelete?: boolean,
      numMeasurements?: number
      result?: ResultType,
      scanner?: ScannerStatus,
    },         render?: boolean) => Promise<void>),
    getStep: (() => {
      result: ResultType;
      serial: string;
      step: string;
      aox: AoxMeasurementResult[];
      idx: number;
      measurements: any[];
      hrvMeasurement: HrvMeasurementData
      numMeasurements: number
    }),
    resetProgress: (() => void),
    resetAll: (() => void),
    getArgs: (() => PipelineStageConfig),
    translateWrapper: ((e: string) => string),
    promptURL: ((url: string) => Promise<any>),
    executeStage: ((stage: string, msg: string, callingStage?: string) => Promise<void>),
    openLink: ((link: string) => void),
    setState: ((key: string, val?: any, group?: string, isRadio?: boolean, buttonGroup?: string, type?: string) => void),
    clearState: ((group: string) => Promise<void>),
    handleFunction: ((func: ElementDesign['handleFunction'], val?: string, goTo?: string, valList?: string[]) => Promise<void>),
    checkElement: ((elementName: string) => boolean),
    resetFactory: (() => Promise<void>),
    fetchAppConfig: ((reload?: boolean) => Promise<void>),
    shareMeasurementResults: ((custom?: boolean) => void),
    shareResults: (() => void),
    reload: (() => Promise<void>),
    getProgress: (index: number) => number;
    getProgressStatus: (index: number) => boolean;
    onKeyboardInput: (e: [string, any]) => void;
  };
  public appConfigService: AppConfigService;


  get kioskMode(): boolean {
    const designFlag = this.helperFunctions?.getState(State.virtualKeyboard) === true;
    const result =  this._kioskMode
      || (environment.appDesignSettings?.virtualKeyboard === true)
      || designFlag;
    return result;
  }


  constructor(
    private alertCtrl: AlertController,
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private scannerApi: ScannerApiService,
    private apiBasicService: ApiBasicService,
    private genConfigService: GenConfigService,
    private networkService: NetworkService,
    private network: Network,
    private router: Router,
    private insomnia: Insomnia,
    private platform: Platform,
    private iab: InAppBrowser,
    private windowService: WindowObservablesService,
    private cd: ChangeDetectorRef,
    private screenOrientation: ScreenOrientation,
    private navbar: NavigationBar,
    private afs: AndroidFullScreen,
    private fileManager: FileManagerService,
    public checkerDataService: CheckerDataService,
    private sanitizer: DomSanitizer,
    appConfigService?: AppConfigService,
    private virtualKeyboardService?: VirtualKeyboardService,
  ) {
    this.appConfigService = appConfigService;
    this.helperFunctions = new HomePageHelpers(this);
    void this.initializeRuntimeFlags();
  }

  private async initializeRuntimeFlags(): Promise<void> {
    await this.platform.ready();
    this.isElectron = this.platform.is('electron');
    if (this.isElectron) {
      this._kioskMode = await this.resolveElectronFlag(window.electronAPI?.isKioskMode);
      this.cd.detectChanges();

      void this.initializeConfigCheckerFlag();
    } else {
      this._kioskMode = false;
      this.configCheckerEnabled = false;
      this.cd.detectChanges();
    }
  }

  private async initializeConfigCheckerFlag(): Promise<void> {
    this.configCheckerEnabled = await this.resolveElectronFlag(
      window.electronAPI?.isConfigCheckerEnabled,
    );
    this.cd.detectChanges();
  }

  private async resolveElectronFlag(getFlag?: () => Promise<boolean>): Promise<boolean> {
    if (!getFlag) {
      return false;
    }

    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    const timeout = new Promise<boolean>(resolve => {
      timeoutId = setTimeout(() => {
        resolve(false);
      }, 2000);
    });

    try {
      const request = getFlag()
        .then(enabled => enabled ?? false)
        .catch(() => false);
      return await Promise.race([request, timeout]);
    } catch {
      return false;
    } finally {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
    }
  }

  /**
   * is called whenever the user navigates to this site
   * subscribe to all persistent services
   */
  async ionViewWillEnter() {
    this.lastPage = '';
    try {
      this.helperFunctions.setAlive(false);
      delete this.helperFunctions;
    } catch (e) { }
    this.helperFunctions = new HomePageHelpers(this);
    this.orientationValue = this.screenOrientation?.ORIENTATIONS?.PORTRAIT_PRIMARY ?? '';
    this.helperFunctions.registerBackButtonEvent();
    if (this.platform.is('cordova') && this.platform.is('android')) {
      await this.afs.immersiveMode();
    }
    if ((window as any).MobileAccessibility) {
      (window as any).MobileAccessibility.usePreferredTextZoom(false);
    }
    this.windowSizeSubscription?.unsubscribe();
    this.windowSizeSubscription = this.windowService.windowSize.subscribe(async (w) => {
      this.windowDim = w;
      const { elements: e, pageConfig: pC } = genElements(this.step, this.state, this.media);
      this.setElementConfig(e, pC);
      await new Promise(a => setTimeout(a, 500));
      this.helperFunctions.shrinkText();
      this.cd.detectChanges();
    });

    this.helperFunctions.initPage();
  }

  async ionViewWillLeave() {
    clearTimeout(this.timeout);
    this.windowSizeSubscription?.unsubscribe();
    this.windowSizeSubscription = undefined;
    if (this.platform.is('cordova')) {
      await this.insomnia.allowSleepAgain();
    }
    // await this.networkService.disconnectScanner(this.state.persistentValues);
    await this.scannerApi.disconnectScanner(this.state.persistentValues);
  }

  navigate(url: string) {
    this.helperFunctions.setAlive(false);
    delete this.helperFunctions;
    this.router.navigateByUrl(url);
  }

  openCheckerSettings() {
    this.checkerDataService.isCheckerActive = true;
    this.checkerDataService.setHomePage(this);
    void this.router.navigate(['/config-checker-settings']);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    clearTimeout(this.timeout);
    this.windowSizeSubscription?.unsubscribe();
  }

  private prepareIframeUrls(elements) {
    if (!elements) {
      return elements;
    }
    for (const element of Object.values(elements) as ElementDesign[]) {
      if (element.elementType !== 'iframe' && element.elementType !== 'iframePost') {
        continue;
      }
      const rawUrl = element.design ?? '';
      let trustedUrl = this.trustedIframeUrls.get(rawUrl);
      if (!trustedUrl) {
        trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
        this.trustedIframeUrls.set(rawUrl, trustedUrl);
      }
      element.trustedResourceUrl = trustedUrl;
    }
    return elements;
  }

  setElementConfig(elements, pageConfig?: Record<string, any>) {
    this.elementConfig = this.prepareIframeUrls(elements);
    if (pageConfig !== undefined) {
      this.pageConfig = pageConfig;
    }
  }

  ngAfterViewChecked() {
    const elIF = document.forms['postIframe'] as HTMLFormElement | undefined;
    const postIframeKey = this.getPostIframeKey();
    if (!elIF || !postIframeKey) {
      this.submittedPostIframeKey = '';
      return;
    }
    // only submit post iframes once per rendered iframe identity
    if (!this.didPostIframe && this.submittedPostIframeKey !== postIframeKey) {
      this.didPostIframe = true;
      this.submittedPostIframeKey = postIframeKey;
      elIF.submit();
    }
  }

  onKeyboardInput(e: [string, any]) {
    this.helperFunctions.onKeyboardInput(e);
  }

  focusNextVirtualKeyboardInput() {
    if (this.isElectron) {
      this.virtualKeyboardService?.focusNextInput();
    }
  }

  trackByKey = (index: number, item: KeyValue<string, any>): string => {
    return this.getElementTrackKey(item.key, item.value);
  }

  private getElementTrackKey(key: string, element: ElementDesign): string {
    if (element.keepActive) {
      return key;
    }
    if (element.elementType === 'iframe' || element.elementType === 'iframePost') {
      return `${this.lastPage}_${key}_${element.design ?? ''}`;
    }
    return `${this.lastPage}_${key}`;
  }

  private getPostIframeKey(): string | undefined {
    const postIframeEntry = Object.entries(this.elementConfig ?? {})
      .find(([, element]: [string, ElementDesign]) => element.elementType === 'iframePost') as [string, ElementDesign] | undefined;
    if (!postIframeEntry) {
      return undefined;
    }
    return this.getElementTrackKey(postIframeEntry[0], postIframeEntry[1]);
  }

  isScrollTextOverflowing(element?: HTMLElement): boolean {
    if (!element) {
      return false;
    }
    return element.scrollHeight > element.clientHeight + 1;
  }

  shouldShowScrollTextHint(element?: HTMLElement): boolean {
    if (!this.isScrollTextOverflowing(element)) {
      return false;
    }
    return element.scrollTop + element.clientHeight < element.scrollHeight - 1;
  }

  onScrollTextScroll() {
    this.cd.detectChanges();
  }

  genQrSize(css: { width: string; height: string }): number {
    const resolve = (val: string, dim: number) =>
      val.includes('px') ? +val.replace('px', '') : +val.replace('%', '') * dim * 0.01;

    return Math.min(
      resolve(css.width, this.windowDim.w),
      resolve(css.height, this.windowDim.h)
    );
  }
}
